import auth from 'src/router/middleware/authentification/auth.js'
import recentAuth from 'src/router/middleware/authentification/recentAuth.js'
import managementRedirect from 'src/router/middleware/management/managementRedirect.js'
import timeGrid from 'src/router/middleware/timeGrid/timeGrid.js'
import schoolYearChangeEnabled from 'src/router/middleware/management/schoolYearChangeEnabled.js'
import absenceTypesEditable from 'src/router/middleware/management/absenceTypesEditable.js'

import userComparison from 'src/router/routes/management/user-comparision.js'

const SingleSchoolUploadView = () => import('src/views/Management/Schools/Views/SingleSchoolUploadView.vue')
const SchoolYearsList = () => import('src/views/Management/Schools/Views/SchoolYearsList.vue')
const AdminTimetableWebInterface = () => import('src/views/Management/TimteableUploader/TimetableUploaderInterface.vue')
const GradeUpgrade = () => import('src/views/Management/GradeUpgrade/GradeUpgrade.vue')
const AdminTimetableWebInterfaceAutomatic = () => import('src/views/Management/TimteableUploader/TimetableUploaderAutomatic.vue')
const WebInterfaceWrapper = () => import('src/views/Management/TimteableUploader/TimetableUploaderWrapper.vue')
const SchoolStatistics = () => import('src/views/Management/Overview/Overview.vue')
const IntroSchoolyearCheckup = () => import('src/views/Management/SchoolYearChange/SchoolYearChangeIntroSchoolyearCheckup.vue')
const InstantSchoolYearChange = () => import('src/views/Management/SchoolYearChange/SchoolYearChangeInstant.vue')
const AdminTimetableWebInterfaceStatus = () => import('src/views/Management/TimteableUploader/TimetableUploaderStatus.vue')
const UserCreationHistory = () => import('src/views/Management/Users/UserCreationHistory.vue')
const SchoolQuotations = () => import('src/views/Management/Schools/SchoolQuotations.vue')
const SchoolActivationDetails = () => import('src/views/Management/SchoolActivation/SchoolActivationDetails.vue')
const AbsenceCategories = () => import('src/views/Management/AbsenceCategories/AbsenceCategories.vue')
const Exports = () => import('src/views/Management/Exports/Exports.vue')
const SchoolActivationWrapper = () => import('src/views/Management/SchoolActivation/SchoolActivationWrapper.vue')
const SchoolActivationDone = () => import('src/views/Management/SchoolActivation/SchoolActivationDone.vue')
const ManagementDeletedUserAccounts = () => import('src/views/Management/Users/ManagementDeletedUserAccounts.vue')
const ManagementDeletionPendingUserAccounts = () => import('src/views/Management/Users/ManagementDeletionPendingUserAccounts.vue')
const ManagementDeletionRequestUserAccounts = () => import('src/views/Management/Users/ManagementDeletionRequestUserAccounts.vue')
const ManagementArchivedUserAccounts = () => import('src/views/Management/Users/ManagementArchivedUserAccounts.vue')
const UserDuplicated = () => import('src/views/Management/Users/UserDuplicated.vue')
const ManagementUsersWrapper = () => import('src/views/Management/Users/ManagementUsersWrapper.vue')
const Wrapper = () => import('src/views/Management/AdministrationWrapper.vue')
const ManagementTimetable = () => import('src/views/Management/Timetable/TimetablePagePlanner.vue')
const ManagementData = () => import('src/views/Management/Basedata/Basedata.vue')
const UserManagement = () => import('src/views/Management/Users/UserManagement.vue')
const SchoolDataWrapper = () => import('src/views/Management/Schools/Views/SchoolDataWrapper.vue')
const EditSchool = () => import('src/views/Management/Schools/Views/EditSchool.vue')
const SchoolSettings = () => import('src/views/Management/Schools/Views/SchoolSettings.vue')
const AuthenticationDriver = () => import('src/views/Management/Schools/Views/AuthenticationDriver.vue')
const EditSchoolBilling = () => import('src/views/Management/Schools/Views/EditSchoolBilling.vue')
const EditEncryptionSettings = () => import('src/views/Management/Schools/Views/EditEncryptionSettings.vue')
const SchoolAdditionalContent = () => import('src/views/Management/Schools/Views/SchoolAdditionalContent.vue')
const AllGroupsPreview = () => import('src/views/Management/Groups/GroupList.vue')
const EditChannelWrapper = () => import('src/views/Channels/Channel/Editing/ChannelEditWrapper.vue')
const EditChannel = () => import('src/views/Channels/Channel/Editing/ChannelEdit.vue')
const QueryNotification = () => import('src/views/Management/Notifications/QueryNotification.vue')
const ManageSchoolRoles = () => import('src/views/Management/Roles/Roles.vue')
const EditRole = () => import('src/views/Management/Roles/RoleEdit.vue')
const EditAbsenceCategory = () => import('src/views/Management/AbsenceCategories/AbsenceEditCategories.vue')
const ManageTimetablePeriods = () => import('src/views/Management/Periods/Periods.vue')

const GenerateUsersWrapper = () => import('src/views/Management/Users/GenerateUsersWrapper.vue')
const GenerateUsersUpload = () => import('src/views/Management/Users/GenerateUsersUpload.vue')
const GenerateUsersManual = () => import('src/views/Management/Users/GenerateUsersManual.vue')
const Policies = () => import('src/views/Management/Policies/Policies.vue')
const EditPolicy = () => import('src/views/Management/Policies/PolicyEdit.vue')
const AdvancedTimeTablePlanner = () => import('src/views/Management/AdvancedTimeTablePlanner/AdvancedTimeTablePlanner.vue')

export default [
  {
    path: '/management/:schoolUuid',
    component: Wrapper,
    name: 'tt-management-wrapper',
    meta: {
      middleware: [auth, managementRedirect],
      switchManagementData: true,
      enableSwReload: true,
      headerText: 'global.headers.administration'
    },
    children: [
      ...[
        {
          path: 'timetable/:entity/:id',
          component: ManagementTimetable,
          name: 'management-timetable',
          meta: {
            middleware: [auth, managementRedirect, timeGrid],
            group: 'timetable',
            switchManagementData: true,
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'web-interface',
          component: WebInterfaceWrapper,
          name: 'web-interface-wrapper',
          meta: {
            middleware: [auth, managementRedirect],
            switchManagementData: true,
            group: 'web-interface-wrapper',
            headerText: 'global.headers.administration'
          },
          children: [
            {
              path: 'upload',
              component: AdminTimetableWebInterface,
              name: 'school-timetable-web-interface',
              meta: {
                group: 'web-interface',
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'automatic-upload',
              component: AdminTimetableWebInterfaceAutomatic,
              name: 'school-timetable-web-interface-auto',
              meta: {
                group: 'web-interface',
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'status',
              component: AdminTimetableWebInterfaceStatus,
              name: 'school-timetable-web-interface-status',
              meta: {
                group: 'school-timetable-web-interface-status',
                headerText: 'global.headers.administration'
              }
            }
          ]
        },
        {
          path: 'advanced-timetable',
          component: AdvancedTimeTablePlanner,
          name: 'advanced-timetable-planner',
          meta: {
            middleware: [auth, managementRedirect],
            group: 'advanced-timetable',
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'grade-upgrade',
          component: GradeUpgrade,
          name: 'school-grade-upgrade',
          meta: {
            middleware: [auth, managementRedirect, schoolYearChangeEnabled],
            group: 'school-year-change-type',
            switchManagementData: true,
            headerText: 'global.headers.schoolyearchange'
          }
        },
        {
          path: 'school-stats',
          component: SchoolStatistics,
          name: 'school-stats',
          meta: {
            middleware: [auth, managementRedirect],
            group: 'statistics',
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'submit-query',
          component: QueryNotification,
          name: 'submit-query',
          meta: {
            middleware: [auth, managementRedirect],
            switchManagementData: true,
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'basedata/:entity',
          component: ManagementData,
          name: 'tt-management-basedata',
          meta: {
            middleware: [auth, managementRedirect],
            switchManagementData: true,
            group: 'basedata',
            preventScrollTop: true,
            headerText: 'global.headers.administration'
          }
        },
        /* {
          path: 'user',
          component: SingleSchoolUserView,
          name: 'school-single-create-user',
          meta: {
            middleware: [ auth, managementRedirect],
            group: 'school-create-user'
          }
        }, */
        {
          path: 'user-creation-history',
          component: UserCreationHistory,
          name: 'school-single-create-user-history',
          meta: {
            middleware: [auth, managementRedirect],
            group: '',
            preventScrollTop: true,
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'upload',
          component: SingleSchoolUploadView,
          name: 'school-single-upload',
          meta: {
            middleware: [auth, managementRedirect],
            group: 'school-upload',
            switchManagementData: true,
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'years',
          component: SchoolYearsList,
          name: 'school-years',
          meta: {
            middleware: [auth, managementRedirect],
            switchManagementData: true,
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'school-additional-content',
          component: SchoolAdditionalContent,
          name: 'school-additional-content',
          meta: {
            middleware: [auth, managementRedirect],
            switchManagementData: true,
            group: 'additional-content',
            preventScrollTop: true,
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'periods/schoolyears/:schoolyear?',
          component: ManageTimetablePeriods,
          name: 'tt-management-timetable-periods',
          meta: {
            middleware: [auth],
            group: 'periods',
            preventScrollTop: true,
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'roles',
          component: ManageSchoolRoles,
          name: 'tt-management-roles',
          meta: {
            middleware: [auth],
            headerText: 'global.headers.administration'
          },
          children: [
            {
              path: ':roleId?',
              name: 'management-roles-details',
              component: EditRole,
              meta: {
                group: 'manage-roles',
                headerText: 'global.headers.administration'
              }
            }
          ]
        },
        {
          path: 'absence-categories',
          component: AbsenceCategories,
          name: 'management-absence-categories',
          meta: {
            middleware: [auth, absenceTypesEditable],
            group: 'absence-categories',
            headerText: 'global.headers.administration'
          },
          children: [
            {
              path: ':absenceTypeId?',
              name: 'management-absence-categories-details',
              component: EditAbsenceCategory,
              meta: {
                group: 'absence-categories',
                headerText: 'global.headers.administration'
              }
            }
          ]
        },
        {
          path: 'policies',
          component: Policies,
          name: 'management-policies',
          meta: {
            middleware: [auth],
            group: 'policies',
            headerText: 'global.headers.administration'
          },
          children: [
            {
              path: ':actor?',
              name: 'management-policies-details',
              component: EditPolicy,
              meta: {
                group: 'policies',
                headerText: 'global.headers.administration'
              }
            }
          ]
        },
        {
          path: 'exports/:classbook',
          component: Exports,
          name: 'management-exports',
          meta: {
            middleware: [auth, recentAuth],
            group: 'exports',
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'users',
          component: ManagementUsersWrapper,
          name: 'tt-management-users-wrapper',
          meta: {
            middleware: [auth, managementRedirect],
            group: 'users',
            headerText: 'global.headers.administration'
          },
          children: [
            {
              path: 'users',
              component: UserManagement,
              name: 'tt-management-users',
              meta: {
                middleware: [auth, managementRedirect],
                group: 'users',
                preventScrollTop: true,
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'deleted-users',
              component: ManagementDeletedUserAccounts,
              name: 'tt-management-users-deleted',
              meta: {
                middleware: [auth],
                group: 'users',
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'deletion-pending-users',
              component: ManagementDeletionPendingUserAccounts,
              name: 'tt-management-users-deletion-pending',
              meta: {
                middleware: [auth, managementRedirect],
                group: 'users',
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'deletion-request-users',
              component: ManagementDeletionRequestUserAccounts,
              name: 'tt-management-users-deletion-request',
              meta: {
                middleware: [auth, managementRedirect],
                group: 'users',
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'archived-users',
              component: ManagementArchivedUserAccounts,
              name: 'tt-management-users-archived',
              meta: {
                middleware: [auth, managementRedirect],
                group: 'users',
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'duplicated',
              component: UserDuplicated,
              name: 'tt-management-users-duplicated',
              meta: {
                middleware: [auth, managementRedirect],
                group: 'users',
                headerText: 'global.headers.administration'
              }
            }
          ]
        },

        {
          path: 'channels',
          component: AllGroupsPreview,
          name: 'tt-management-channels',
          meta: {
            group: 'channels',
            middleware: [auth],
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'channels/:id/:view?',
          component: EditChannelWrapper,
          meta: {
            middleware: [auth],
            headerText: 'global.headers.administration'
          },
          children: [
            {
              path: '',
              component: EditChannel,
              name: 'tt-management-channels-edit',
              meta: {
                headerText: 'global.headers.administration'
              }
            }
          ]
        },
        {
          path: 'school-year-change-validation',
          component: IntroSchoolyearCheckup,
          name: 'school-year-change-validation',
          meta: {
            middleware: [auth, managementRedirect],
            group: 'school-year-change-type',
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'instant-school-year-change',
          component: InstantSchoolYearChange,
          name: 'instant-school-year-change',
          meta: {
            middleware: [auth, managementRedirect, schoolYearChangeEnabled],
            group: 'school-year-change-type',
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'school-data',
          name: 'school-data-wrapper',
          component: SchoolDataWrapper,
          meta: {
            middleware: [auth],
            group: 'school',
            headerText: 'global.headers.administration'
          },
          children: [
            {
              path: 'edit-school',
              component: EditSchool,
              name: 'edit-school',
              meta: {
                middleware: [auth, managementRedirect],
                switchManagementData: true,
                group: 'school',
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'edit-settings',
              component: SchoolSettings,
              name: 'edit-settings',
              meta: {
                middleware: [auth, managementRedirect],
                switchManagementData: true,
                group: 'school',
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'authentication-driver',
              component: AuthenticationDriver,
              name: 'authentication-driver',
              meta: {
                middleware: [auth, managementRedirect],
                switchManagementData: true,
                group: 'school',
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'edit-school-billing',
              component: EditSchoolBilling,
              name: 'edit-school-billing',
              meta: {
                middleware: [auth, managementRedirect],
                switchManagementData: true,
                group: 'school',
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'edit-encryption-settings',
              component: EditEncryptionSettings,
              name: 'edit-encryption-settings',
              meta: {
                middleware: [auth, managementRedirect],
                switchManagementData: true,
                group: 'school',
                headerText: 'global.headers.administration'
              }
            }
          ]
        },
        {
          path: 'generate-users',
          component: GenerateUsersWrapper,
          name: 'generate-users',
          meta: {
            middleware: [auth, managementRedirect],
            switchManagementData: true,
            group: 'generate-users',
            headerText: 'global.headers.administration'
          },
          children: [
            {
              path: 'upload',
              component: GenerateUsersUpload,
              name: 'generate-users-upload',
              meta: {
                group: 'generate-users',
                preventScrollTop: true,
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'manual',
              component: GenerateUsersManual,
              name: 'generate-users-manual',
              meta: {
                group: 'generate-users',
                preventScrollTop: true,
                headerText: 'global.headers.administration'
              }
            }
          ]
        },
        {
          path: 'school-quotations',
          component: SchoolQuotations,
          name: 'management-school-quotations',
          meta: {
            middleware: [auth],
            group: 'school-quotations',
            headerText: 'global.headers.administration'
          }
        },
        {
          path: 'activation/:uuid?',
          component: SchoolActivationWrapper,
          name: 'school-activation-wrapper',
          meta: {
            middleware: [auth, managementRedirect],
            group: 'school-quotations',
            headerText: 'global.headers.administration'
          },
          children: [
            {
              path: 'details',
              component: SchoolActivationDetails,
              name: 'school-activation-details',
              meta: {
                middleware: [auth, managementRedirect],
                group: 'school-quotations',
                headerText: 'global.headers.administration'
              }
            },
            {
              path: 'data',
              name: 'school-activation-school-data-wrapper',
              component: SchoolDataWrapper,
              meta: {
                middleware: [auth, managementRedirect],
                group: 'school-quotations',
                headerText: 'global.headers.administration'
              },
              children: [
                {
                  path: 'properties',
                  component: SchoolSettings,
                  name: 'school-activation-properties',
                  meta: {
                    middleware: [auth, managementRedirect],
                    switchManagementData: true,
                    group: 'school-quotations',
                    headerText: 'global.headers.administration'
                  }
                },
                {
                  path: 'auth-drivers',
                  component: AuthenticationDriver,
                  name: 'school-activation-auth',
                  meta: {
                    middleware: [auth, managementRedirect],
                    switchManagementData: true,
                    group: 'school-quotations',
                    headerText: 'global.headers.administration'
                  }
                },
                {
                  path: 'activation-done',
                  component: SchoolActivationDone,
                  name: 'school-activation-done',
                  meta: {
                    middleware: [auth, managementRedirect],
                    switchManagementData: true,
                    group: 'school-quotations',
                    headerText: 'global.headers.administration'
                  }
                }
              ]
            }
          ]
        }
      ], ...userComparison
    ]
  }
]
